export const OverviewDetailsOptions = {
       submittedRevenue : "SR",
       unsubmittedRevenue : "USR" 
}